import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import { withLocale } from 'core/decorators';
import services from 'core/services';
import  ReactHtmlParser from "react-html-parser";


import { PureComponent, Serialize, Loading, GroupBox } from 'core/components';
import { Row, Stepper, Button, Icon, Swiper, SwiperSlide, Preloader, PhotoBrowser, Col, CardContent, CardFooter, Link } from 'core/components/Framework7'
import { addToCart, changeCountItem, deleteItem } from 'content/pages/Cart/Module';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import classes from './styles.module.css';

const Price = Serialize.Price;

class Product extends PureComponent {
  constructor(props) {
    super(props)

    // console.log('product props:', props)

    this.state = {
      loading: false,
      ...this.initialValue
    }

    this.debouncedHandleStepper = debounce(this.handleChangeStepper, 500);

    this.stepperElm = React.createRef()
    this.photoBrowserElm = React.createRef()
  }

  // componentDidMount() {
  //   // set defaults
  //   this.resetState()
  // }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.cart == this.props.cart ||
      this.state.currentValue == this.productCountInCart(this.state.item.id)
    )
      return

    // console.log('componentDidUpdate in product component:', this.props)

    this.resetState()
  }

  resetState() {
    this.setState(this.initialValue)
  }

  get initialValue() {
    const { cart } = this.props;
    const item = this.parseProductItem();
    const cartItemId = item && cart && services.utils.product.cartItemId(cart, item.id);

    // console.log("item", item, "cart", cart);

    return {
      item: item,
      cartId: cartItemId,
      currentValue: item.productCount,
      latestValue: item.productCount,
    }
  }

  /**
   * parse item of category
   * @param {Object} item 
   */
  parseProductItem() {
    const { item, photos } = this.props;
    // console.log("item", item);

    return {
      id: item ? item.id : null,
      name: item ? item.name : null,
      description: item ? item.description : null,
      currentPrice: item ? item.currentPrice : null,
      currentDiscount: item ? item.currentDiscount : 0,
      consumerPrice: item ? item.consumerPrice : null,
      productCount: this.productCountInCart(item && item.id),
      quantity: item ? item.quantity : 0,
      photos: photos,
      unitType: item ? item?.unitType : null,
      limitBuyQuantity: item ? item?.limitBuyQuantity : 0,
      zoomPhotos: services.utils.url.getSizedImage(photos, 9),
    }
  }

  changeStepper(value) {
    if (this.state.currentValue == value) return

    // console.log('changeStepper => ', 'value:', value)

    this.setState({
      currentValue: value,
    }, () => {
      this.debouncedHandleStepper();
    })
  }

  handleChangeStepper() {
    const { item, cartId, currentValue } = this.state;
    const { minimumValue } = item?.unitType || {};

    console.log("minimumValue in produvt", minimumValue);

    this.setState({ loading: true })

    const params = {
      store: 2,
      errorHandler: true
    }

    const model = {
      count: currentValue,
      orderId: null,
      productId: item.id
    }

    const cartItemExists = cartId != null

    // item exists in cart
    if (cartItemExists) {
      // delete from cart when item count set to 0
      if (currentValue < minimumValue) {
        this.deleteItem(cartId)
      } else {
        // change cart item count
        return this.props.changeCountItem(cartId, { count: currentValue }, params)
          .then(r => { this.resetState() })
          .catch(this.handleAPICatch)
          .finally(r => { this.setState({ loading: false }) })
      }
    } else {
      return this.props.addToCart(model, params)
        .then(r => { this.resetState() })
        .catch(this.handleAPICatch)
        .finally(r => { this.setState({ loading: false }) })
    }
  }

  deleteItem(cartId) {
    this.$f7.dialog.confirm("آیا از حذف کالا اطمینان دارید؟", "حذف",
      () => this.deleteCartItem(cartId),
      () => {
        this.$f7.dialog.close()
        this.handleAPICatch()
      }
    )
  }

  deleteCartItem(cartId) {
    return this.props.deleteItem(cartId, { store: 2 })
      .then(r => { this.resetState() })
      .catch(this.handleAPICatch)
      .finally(r => { this.setState({ loading: false }) })
  }

  handleAPICatch(err) {
    const msg = (err && err.message) || ''
    const outOfStock = msg.indexOf("insufficient stock quantity") == 0
    if (outOfStock) {
      this.$f7.dialog.alert('تعداد کالای انتخابی از موجودی فروشگاه بیشتر است.', 'خطا')
    } else {
      this.$f7.dialog.alert('خطایی رخ داده، لطفا دوباره تلاش کنید', 'خطا');
    }

    this.setState(prevState => ({
      currentValue: outOfStock && prevState.latestValue > prevState.currentValue ? prevState.currentValue : prevState.latestValue,
      loading: false,
    }), () => {
      if (this.stepperElm.current)
        this.stepperElm.current.setValue(this.state.currentValue)
    })
  }

  productCountInCart(productId) {
    const { cart } = this.props

    if (!productId)
      return 0

    for (const c of cart) {
      if (c.product.id === productId) {
        return c.count
      }
    }

    return 0
  }

  renderCounter(item) {
    const productCount = this.productCountInCart(item.id)

    // console.log('productCount:', productCount, "item", item);

    if (item.quantity < item.unitType?.minimumValue) return this.renderNotCounter();

    if (productCount) return this.renderProductCounter(item, productCount)

    return this.renderCounterBTN(item.unitType?.minimumValue || 0);
  }

  renderCounterBTN(minimumValue) {
    const { loading } = this.state;

    return (
      <Button outline
        className={classes.addToBasketBtn}
        onClick={() => this.changeStepper(minimumValue)}
      >
        {loading
          ? <Preloader size={20} />
          : <React.Fragment>
            <Icon icon="mdi-cart-plus" />
            <span>{'افزودن به سبد خرید'}</span>
          </React.Fragment>}
      </Button>
    )
  }

  renderProductCounter(item, productCount) {
    const { loading, currentValue } = this.state;
    const { unitType, limitBuyQuantity, quantity } = item;
    let maxValue = (limitBuyQuantity && limitBuyQuantity > 0) ? Math.min(limitBuyQuantity, quantity, unitType?.maximumValue) : Math.min(quantity, unitType?.maximumValue);

    // console.log("maxValue is:", maxValue);

    return (
      <Stepper
        ref={this.stepperElm}
        disabled={loading}
        input={false}
        autorepeat={true}
        value={currentValue}
        step={unitType.step}
        max={maxValue ?? null}
        className={classes.stepper}
        onStepperChange={this.changeStepper}
      />
    )
  }

  renderNotCounter() {
    return (
      <div style={{ textAlign: 'center' }}>
        {'ناموجود'}
      </div>
    )
  }

  onErrorImage(e) {
    const { env } = this.props
    const noPhotoURL = env && env.layout.assets.images.noPhoto
    return e.target.src = noPhotoURL
  }

  renderSlider() {
    const { loading } = this.props;

    if (loading)
      return <Loading height={280} />

    return (
      <GroupBox outline style={{ paddingTop: "75%" }}>
        <Swiper
          params={{
            autoplay: false,
            loop: false,
            lazy: true
          }}
          pagination={true}
          navigation={true}
          scrollbar={false}
          className={classes.swiper}
        >
          {this.renderSwiperSlider()}
        </Swiper>
      </GroupBox>
    )
  }

  renderSwiperSlider() {
    const { item } = this.state;
    const { photos } = item
    // console.log('photos:', photos)

    if (!photos || photos.length == 0)
      return this.renderEmpty()

    return photos.map((photo, index) => {
      // console.log('photo:', photo)
      return (
        <SwiperSlide
          key={index}
          className={classes.slide}
        >
          <div className={classes.slideContainer}>
            <img
              alt={photo.caption && photo.caption.length > 0 ? photo.caption : item.name}
              src={services.utils.url.image(photo, 7)}
              srcSet={photo.url && services.utils.imageSourceSizes.srcSet(photo.url)}
              sizes="100vw"
              onError={this.onErrorImage}
              onClick={() => this.photoBrowserElm.current.open()}
            />
          </div>
        </SwiperSlide>
      );
    });
  };

  renderEmpty() {
    return (
      <div className={`${classes.empty} no-photo`} />
    )
  }

  renderProperties() {
    const { item, cartId } = this.state;
    // console.log("item", item)
    return (
      <GroupBox outline className={classes.itemPropBox}>
        <CardContent>
          <Row className={[classes.topRowProduct, item.productCount > item.quantity ? classes.productUnavailable : ''].join(' ')}> {/* onClick={() => this.deleteItem(item)} */}
            {/* show small image when sticky activated */}
            {!true && <Col width="30" className={classes.productImage}>
              <Link href={false}>
                <img src={item.url} alt="product" />
              </Link>
            </Col>
            }
            <Col width={true ? "80" : "50"} >
              <div className={classes.titleProduct}>{item.name}</div>
              <div className={classes.discountPrice}>
                {item.currentDiscount > 0 &&
                  <React.Fragment>
                    <del><Price price={item.currentPrice} hasExtension={false} /></del>
                    <span className={classes.discountFlag}>{'٪'}{Math.floor(item.currentDiscount)} {false && 'تخفیف'}</span>
                  </React.Fragment>
                }
              </div>
              <div className={classes.price}>
                <Price price={item.consumerPrice} />
              </div>
            </Col>
            <Col width="20">
              <p className={classes.discountP}>{'جمع تخفیف'}</p>
              <p className={classes.sumDiscountPrice}><Price price={(item.currentPrice - item.consumerPrice) * item.productCount} /></p>
              <p className={classes.discountP}>{'جمع پرداخت'}</p>
              <p className={classes.sumPrice}><Price price={item.consumerPrice * item.productCount} /></p>
            </Col>
          </Row>
          {item.productCount > item.quantity &&
            <Row>
              <Col width="100" className={classes.noQuantity}>
                {'تعداد کالای انتخابی از موجودی فروشگاه کمتر است.'}
              </Col>
            </Row>
          }
        </CardContent>

        {!cartId && item.quantity <= 0 ?
          <CardFooter>
            <Row>
              <Col width="100">
                {this.renderNotCounter()}
              </Col>
            </Row>
          </CardFooter>
          :
          <CardFooter>
            <Row>
              <Col width={item.productCount <= item.quantity ? "10" : "55"}>
                {cartId &&
                  <Link className={classes.trash} onClick={(e) => this.deleteItem(cartId)}>
                    <Icon icon="mdi-trash-can-outline" />
                    {item.productCount > item.quantity && false &&
                      <span>
                        {'این تعداد کالا موجود نیست'}
                      </span>
                    }
                  </Link>
                }
              </Col>
              <Col width={item.productCount <= item.quantity ? "50" : "5"}></Col>
              <Col width="40">
                {this.renderCounter(item)}
              </Col>
            </Row>
          </CardFooter>
        }
      </GroupBox>
    )
  }

  render() {
    const { item } = this.state;

    // console.log('cover:', cover, 'gallery:', gallery)
    // console.log('product component:', item)

    return (
      <React.Fragment>
        {this.renderSlider()}
        {this.renderProperties()}
        {item.description && item.description.length > 0 &&
          <GroupBox outline title={'توضیحات'}>
            <CardContent>
              <div>
                {/* {item.description} */}
                {ReactHtmlParser(item.description)}
              </div>
              {/* <p className={classes.descriptionParagraph}>{item.description}</p> */}
            </CardContent>
          </GroupBox>
        }

        <PhotoBrowser
          ref={this.photoBrowserElm}
          type="popup"
          navbarOfText="از"
          backLinkText="بازگشت"
          popupCloseLinkText="بستن"
          swipeToClose={true}
          popupPush={true}
          photos={item.zoomPhotos}
        // className={classes.photo_browser}
        />
      </React.Fragment >
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
    cart: state.Cart.cart
  }),
  {
    addToCart,
    changeCountItem,
    deleteItem
  }
)(withLocale('home')(autobind(Product)))